// extracted by mini-css-extract-plugin
module.exports = {"Layout":"styles_Layout__mkFDw","Footer":"styles_Footer__7ck5m","bgWrapper":"styles_bgWrapper__M8P0o"};